export const msalConfig = {
  auth: {
    clientId: '966cc2fa-1517-4f85-915d-35a47be9cdea', // This is the ONLY mandatory field that you need to supply.
    authority: 'https://lambertib2c.b2clogin.com/lambertib2c.onmicrosoft.com/B2C_1_signupsignin1', // Choose SUSI as your default authority.
    knownAuthorities: ['lambertib2c.b2clogin.com'], // Mark your B2C tenant's domain as trusted.
    redirectUri: 'https://hke.lamberti.at/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: 'https://hke.lamberti.at/', // Indicates the page to navigate after logout.
    // redirectUri: 'http://localhost:3000/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    // postLogoutRedirectUri: 'http://localhost:3000/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true, // If 'true', will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. 'sessionStorage' is more secure, but 'localStorage' gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to 'true' if you are having issues on IE11 or Edge
  }
}